var map = {
	"./foto1.webp": "f598",
	"./foto2.webp": "8c9b",
	"./foto3.webp": "39fd",
	"./foto_ozuv-1.png": "05f7",
	"./foto_ozuv-2.png": "fda8",
	"./foto_ozuv.png": "e0e0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fc98";